import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  standalone: true,
  imports: [UiModule],
  selector: 'app-expandable-content-header',
  template: `
    <fl-text
      [color]="FontColor.LIGHT"
      [size]="size"
      [sizeTablet]="sizeTablet"
      [weight]="FontWeight.BOLD"
      [flMarginRight]="'mid'"
    >
      <ng-content></ng-content>
    </fl-text>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableContentHeaderComponent {
  FontColor = FontColor;
  FontWeight = FontWeight;

  @Input() size: TextSize = TextSize.MID;
  @Input() sizeTablet: TextSize = TextSize.MID;
}

@Component({
  standalone: true,
  imports: [TrackingModule, UiModule],
  selector: 'app-expandable-content',
  template: `
    <div
      class="Card-header"
      [class.Card-header-borderRadius]="hasBorderRadius"
      tabindex="0"
      [flTrackingLabel]="trackingLabel"
      (click)="handleClick()"
      (keydown.enter)="handleClick()"
    >
      <ng-content select="app-expandable-content-header"></ng-content>
      <fl-icon
        class="ExpandIcon"
        [class.IsExpanded]="expanded"
        [color]="IconColor.LIGHT"
        [name]="'ui-chevron-down'"
        [size]="IconSize.SMALL"
      ></fl-icon>
    </div>
    <div
      class="Card-body"
      [class.Card-body-padding]="hasBodyPadding"
      [class.Card-isExpanded]="expanded"
      [class.Card-isHidden]="!expanded"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./expandable-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableContentComponent {
  IconColor = IconColor;
  IconSize = IconSize;

  expanded = false;

  @Input() hasBodyPadding = false;
  @Input() hasBorderRadius = false;
  @Input() trackingLabel: string;

  handleClick(): void {
    this.expanded = !this.expanded;
  }
}
